import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Share2, Heart, MessageCircle } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { getImageUrl } from '../utils/imageUrl';

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();
  
  const formatPrice = (price) => {
    return price.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <Card className="overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      {/* Image Section */}
      <div className="relative">
        <img 
          src={project.images && project.images.length > 0 ? getImageUrl(project.images[0]) : project.image} 
          alt={project.name}
          className="w-full h-64 object-cover"
        />
        {/* Discount Badge */}
        {project.showDiscount && project.discount > 0 && (
          <div className="absolute top-4 right-4 bg-black text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg">
            {project.discount}%
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="p-6">
        {/* Tags */}
        {project.tags && project.tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-3">
            {project.tags.map((tag, index) => (
              <Badge key={index} variant="secondary" className="bg-gray-100 text-gray-700">
                {tag}
              </Badge>
            ))}
          </div>
        )}

        {/* Title */}
        <h3 className="text-2xl font-bold text-gray-800 mb-3">{project.name}</h3>

        {/* Description */}
        <p className="text-gray-600 mb-4 line-clamp-2">{project.description}</p>

        {/* Project Details */}
        <div className="flex flex-wrap gap-4 mb-4 text-sm text-gray-600">
          {project.area && (
            <span>📐 {project.area}</span>
          )}
          {project.bedrooms && (
            <span>🛏️ {project.bedrooms} quartos</span>
          )}
          {project.bathrooms && (
            <span>🚿 {project.bathrooms} banheiros</span>
          )}
        </div>

        {/* Price and Button */}
        <div className="flex items-center justify-between mt-6">
          <div>
            <p className="text-sm text-gray-500">A partir de</p>
            <p className="text-2xl font-bold" style={{ color: '#00A86B' }}>
              R$ {formatPrice(project.price)}
            </p>
          </div>
          <Button 
            onClick={() => navigate(`/projeto/${project.id}`)}
            className="bg-[#00A86B] hover:bg-[#00A86B]/90 text-white"
          >
            Mais Detalhes
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ProjectCard;
